import allImgPaths from 'assets/images'
import { format } from 'date-fns';
import { isArray } from 'lodash';

interface UserManagementProps {
    activityIcon?: any;
    data: any
    period: any
}

const UserManagement = ({ activityIcon, data, period }: UserManagementProps) => {
    const handleImageError = (e: any) => {
        e.target.src = allImgPaths.defaultProfile
    }

    return (
        <>
            <div className="px-3 pt-3 pb-4 mb-5 last:pb-3 last:mb-0 border-b border-[#F1F1F1] last:border-b-transparent">
                <div className="flex gap-x-4 mb-4">
                    <div className="relative w-10">
                        <img className="min-w-10 h-10 rounded-full" onError={handleImageError} src={data?.user?.profile_image || allImgPaths.defaultProfile} alt="" />
                        <img
                            className="absolute top-7 -right-1 w-5 h-5 rounded-full"
                            src={allImgPaths.historyInvitation}
                            alt=""
                        />
                    </div>

                    <div className="leading-none">
                        <div className="font-interMedium text-base text-[#4F4D55] pb-0.5">
                            <span className="font-interMedium text-base text-[#0A090B]">
                                {data?.action_data?.action_user?.name || 'A user'}
                            </span>

                            {
                                data?.action_data?.fields === 'invite-user' &&
                                <>
                                    <span> invited&nbsp;</span>
                                    <span className="font-interMedium text-base text-[#1851d0]">
                                        {
                                            isArray(data?.action_data?.new_value) && data?.action_data?.new_value.map((nv: any) => nv?.name || nv?.email).join(', ')
                                        }
                                    </span>
                                    <span> to the fete</span>
                                </>
                            }
                            {
                                data?.action_data?.fields === 'visibility-change' &&
                                <>
                                    <span> updated fete visibility from&nbsp;
                                        <span className="font-interMedium text-base text-[#1851d0]">
                                            {data?.action_data?.old_value}
                                        </span>
                                        <span> to </span>
                                        <span className="font-interMedium text-base text-[#1851d0]">
                                            {data?.action_data?.new_value}
                                        </span>
                                    </span>
                                </>
                            }
                            {
                                data?.action_data?.fields === 'role-change' &&
                                <>
                                    <span> changed role of&nbsp;
                                        <span className="font-interMedium text-base text-[#1851d0]">
                                            {data?.action_data?.action_for?.name}
                                        </span>
                                        <span> from </span>
                                        <span className="font-interMedium text-base text-[#1851d0]">
                                            {data?.action_data?.old_value}
                                        </span>
                                        <span> to </span>
                                        <span className="font-interMedium text-base text-[#1851d0]">
                                            {data?.action_data?.new_value}
                                        </span>
                                    </span>
                                </>
                            }
                            {
                                (data?.action_data?.fields === 'remove-user' || data?.action_data?.fields === 'leave-event' || data?.action_data?.fields === 'transfer-ownership') &&
                                <>
                                    {data?.action_data?.fields === 'remove-user' && <span> removed </span>}
                                    {data?.action_data?.fields === 'leave-event' && <span> left </span>}
                                    {data?.action_data?.fields === 'transfer-ownership' && <span> transfered it's ownership </span>}
                                    {
                                        data?.action_data?.fields === 'remove-user' &&

                                        <span className="font-interMedium text-base text-[#1851d0]">
                                            {data?.action_data?.old_value?.name}
                                        </span>
                                    }
                                    <span> from the fete and assigned its tasks to </span>
                                    <span className="font-interMedium text-base text-[#1851d0]">
                                        {data?.action_data?.new_value?.name}
                                    </span>
                                    {/* </span> */}
                                </>
                            }
                            {/* {
                                data?.action_data?.fields === 'leave-event' &&
                                <>
                                    <span> left&nbsp;
                                        <span>from the fete and assigned its tasks to </span>
                                        <span className="font-interMedium text-base text-[#0A090B]">
                                            {data?.action_data?.new_value?.name}
                                        </span>
                                        .
                                    </span>
                                </>
                            } */}
                            {
                                (data?.action_data?.fields === 'task-due-date' || data?.action_data?.fields === 'task-reminder-date') &&
                                <>
                                    <span> marked&nbsp;
                                        <span className="font-interMedium text-base text-[#1751D0]">
                                            {data?.task?.title ? data?.task?.title : data?.card?.title}
                                        </span>
                                        <span> {data?.task?.title ? 'task' : 'card'} </span>
                                        {data?.action_data?.fields === 'task-due-date' ? 'due date' : 'reminder date'}
                                    </span>
                                    {
                                        data?.action_data?.old_value &&
                                        <span className="font-interMedium text-base text-[#1751D0]"> from {format(data?.action_data?.old_value, 'EEEE, MMM d, yyyy')} </span>
                                    }
                                    <span> to </span>
                                    <span className="font-interMedium text-base text-[#1751D0]"> {format(data?.action_data?.new_value, 'EEEE, MMM d, yyyy')} </span>
                                </>
                            }
                            {
                                data?.action_data?.fields === 'task-assign' &&
                                <>
                                    <span> assigned&nbsp;
                                        <span className="font-interMedium text-base text-[#1751D0]">
                                            {data?.task?.title}
                                        </span>
                                        <span> task to </span>
                                    </span>
                                    <span className="font-interMedium text-base text-[#1751D0]"> {data?.action_data?.new_value?.name} </span>
                                </>
                            }

                        </div>
                        <div className="leading-none flex items-center gap-x-2.5">
                            {/* <span className="text-xs text-[#7F7D83]">{format(data?.createdAt, 'hh:mm a')}</span> */}
                            {
                                (period == 'Today' || period == 'Yesterday') &&
                                <span className="text-xs text-[#7F7D83]">
                                    {format(data?.createdAt, 'hh:mm a')}
                                </span>
                            }
                            {
                                period != 'Today' && period != 'Yesterday' &&
                                <span className="text-xs text-[#7F7D83]">
                                    {format(data?.createdAt, 'EEEE, MMM dd yyyy, hh:mm a')}
                                </span>
                            }
                            {
                                data?.block?.title && data?.card?.title &&
                                <>
                                    <span className="w-1 h-1 bg-[#7F7D83] rounded-full block"></span>
                                    <span className="text-xs text-[#7F7D83]">
                                        {data?.block?.title} / {data?.card?.title}
                                    </span>
                                </>
                            }
                            {
                                !data?.block?.title && !data?.card?.title &&
                                <>
                                    <span className="w-1 h-1 bg-[#7F7D83] rounded-full block"></span>
                                    <span className="text-xs text-[#7F7D83]">
                                        Fete Settings
                                    </span>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default UserManagement